import {
	ProcessEditionFormType,
	ProcessGuidesRangeFormType,
} from '@features/processes/interfaces/process-edition.interface';
import { RequestFn } from '@interfaces/requests.interfaces';
import { OptionsObject, SnackbarKey, SnackbarMessage } from 'notistack';
import { Dispatch, SetStateAction } from 'react';
import { UseFormReturn } from 'react-hook-form';

export function handleBackBeforeCloseDialog(
	setBeforeCloseDialog: Dispatch<SetStateAction<boolean>>
): () => void {
	return function () {
		setBeforeCloseDialog(false);
	};
}

export function handleClosePanel(
	{ formState: { dirtyFields } }: UseFormReturn<ProcessGuidesRangeFormType>,
	onClose: () => void,
	setBeforeCloseDialog: Dispatch<SetStateAction<boolean>>
): () => void {
	return function () {
		if (Object.keys(dirtyFields).length > 0) {
			setBeforeCloseDialog(true);
			return;
		}

		onClose();
	};
}

export function handleSaveGuidesRange(
	{ handleSubmit }: UseFormReturn<ProcessGuidesRangeFormType>,
	enqueueSnackbar: (message: SnackbarMessage, options?: OptionsObject) => SnackbarKey,
	onClose: () => void,
	id_proceso: string,
	request: RequestFn,
	requestBackendSuite: RequestFn,
	clienteGeneraNumeracion: boolean,
	form: UseFormReturn<ProcessEditionFormType, any> | undefined,
	setShow: React.Dispatch<React.SetStateAction<boolean>>,
	getDataById: (identificacion: string) => Promise<void>,
	nit: string
): () => void {
	return handleSubmit(async (newData) => {
		try {
			setShow(true);
			const oldData = form?.getValues();
			const response = (await request('clientes/suite-maestro-rangos/rango-maestro', 'POST', {
				id_proceso: Number(id_proceso),
				rango: {
					nombre: newData.nombre,
					direccion: newData.direccion,
					telefono: newData.telefono,
					ciudad: newData.ciudad,
					correo: newData.correo,
					nombre_ciudad: newData.nombre_ciudad,
					consecutivo_desde: Number(newData.consecutivo_desde),
					consecutivo_hasta: Number(newData.consecutivo_hasta),
					prefijo_consecutivo: newData.prefijo_consecutivo,
					consecutivo_actual: Number(newData.consecutivo_actual || 0),
				},
			})) as unknown as {
				isError: boolean;
				message: string;
				data: {
					cliente_genera_numeracion: boolean;
					consecutivo_actual: number;
					consecutivo_desde: number;
					consecutivo_hasta: number;
					edited_fields?: string[] | undefined;
					en_uso: boolean;
					id_rango: number;
					prefijo_consecutivo: string;
					terminado: boolean;
					correo: string;
					direccion: string;
					telefono: string;
					ciudad: string;
					nombre: string;
					nombre_ciudad: string;
				};
			};

			if (response.isError) {
				throw new Error(response.message);
			}
			const ranges = oldData?.ranges.map((r) => ({
				...r,
				cliente_genera_numeracion: false,
				consecutivo_actual: r.consecutivo_actual ?? r.consecutivo_desde,
			}));
			if (response.data) {
				ranges?.push(response.data);
			}
			form?.reset({
				...oldData,
				cliente_genera_numeracion: clienteGeneraNumeracion,
				ranges: ranges,
			});
			form?.getValues();
			await requestBackendSuite('procesos', 'PUT', {
				id_proceso: Number(id_proceso),
				proceso: {
					cliente_genera_numeracion: clienteGeneraNumeracion,
				},
			});
			await getDataById(nit);
			setShow(false);
			onClose();
			// eslint-disable-next-line @typescript-eslint/no-explicit-any
		} catch (error: any) {
			setShow(false);
			if (typeof error === 'string') {
				enqueueSnackbar(error, { variant: 'error' });
			} else if (error.response && error.response.data.message) {
				enqueueSnackbar(error.response.data.message, { variant: 'error' });
			}
		}
	});
}

export function handleSaveGuidesRangeAgw(
	{ handleSubmit }: UseFormReturn<ProcessGuidesRangeFormType>,
	enqueueSnackbar: (message: SnackbarMessage, options?: OptionsObject) => SnackbarKey,
	onClose: () => void,
	request: RequestFn,
	nit: string,
	codigoDiv: string,
	setShow: React.Dispatch<React.SetStateAction<boolean>>,
	getDataById: (identificacion: string) => Promise<void>
): () => void {
	return handleSubmit(async (newData) => {
		try {
			setShow(true);
			const response = await request(
				'clientes/suite-maestro-rangos/rango-agw-maestro',
				'POST',
				{
					identificacion: nit,
					codigo_div: codigoDiv,
					rango: {
						nombre: newData.nombre,
						direccion: newData.direccion,
						telefono: newData.telefono,
						ciudad: newData.ciudad,
						correo: newData.correo,
						nombre_ciudad: newData.nombre_ciudad,
						consecutivo_desde: Number(newData.consecutivo_desde),
						consecutivo_hasta: Number(newData.consecutivo_hasta),
						prefijo_consecutivo: newData.prefijo_consecutivo,
						en_uso: newData.en_uso || false,
					},
				}
			);

			if (response.isError) {
				throw new Error(response.message);
			}
			await getDataById(nit);
			setShow(false);
			onClose();
			// eslint-disable-next-line @typescript-eslint/no-explicit-any
		} catch (error: any) {
			setShow(false); //
			if (typeof error === 'string') {
				enqueueSnackbar(error, { variant: 'error' });
			} else if (error.response && error.response.data.message) {
				enqueueSnackbar(error.response.data.message, { variant: 'error' });
			}
		}
	});
}
